import fetchClient from '@/api/api-client'

export const packageShipping = async body => {
  const result = await fetchClient.post(`/shipping/create/`, body)
  return result.data
}

export const createBatch = async body => {
  await fetchClient.post(`/shipping/createBatchExelot/`, body)
}
